import type { ACF, Page } from 'types';
import React, { memo } from 'react';
import Head from 'next/head';

const ServiceJson: React.FC<
  Pick<ACF, 'product' | 'totalMedicalCardPrice'> &
    Pick<Page, 'seo'> & { stateName: string }
> = memo(({ product, totalMedicalCardPrice, seo, stateName }) => {
  const { name, description, imageUrl } = product;
  const canonical = seo?.canonical;

  const details = {
    '@context': 'https://schema.org/',
    '@graph': [
      {
        '@type': 'Service',
        '@id': `${canonical}#service`,
        name,
        description,
        serviceType: 'Medical marijuana card certification',
        image: imageUrl?.src,
        provider: { '@id': 'https://leafwell.com/#organization' },
        areaServed: { '@type': 'State', name: stateName },
        audience: {
          '@type': 'MedicalAudience',
          audienceType: 'Patient',
        },
        availableChannel: {
          '@type': 'ServiceChannel',
          serviceUrl: canonical,
          availableLanguage: [
            { '@type': 'Language', name: 'English', alternateName: 'en' },
            { '@type': 'Language', name: 'Spanish', alternateName: 'es' },
          ],
        },
        ...(totalMedicalCardPrice && {
          offers: {
            '@type': 'Offer',
            '@id': `${canonical}#offer`,
            price: totalMedicalCardPrice,
            priceCurrency: 'USD',
            availability: 'https://schema.org/InStock',
            url: canonical,
            seller: { '@id': 'https://leafwell.com/#organization' },
          },
        }),
      },
    ],
  };

  return React.createElement(
    Head,
    null,
    React.createElement('script', {
      type: 'application/ld+json',
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(details),
      },
    }),
  );
});

export default ServiceJson;
